import React from 'react'

import {Popover, ListItem, P, S2, IconButton} from '../../../src/components/UI/index.js'

export default class TopBarMenu extends React.Component {
    onNavigate(link) {
        const {history} = this.props
        history.push(link)
        this.popover?.close()
    }

    render() {
        const {reseller, user, icon, links} = this.props

        return (
            <Popover
                placement='left'
                ref={(ref) => this.popover = ref}
                content={
                    <div>
                        <ListItem style={{flexDirection: 'column', justifyContent: 'center'}}>
                            <P>{user.name}</P>
                            <S2 ellipsis style={{maxWidth: 200}}>{reseller.settings?.accountName || reseller.name}</S2>
                        </ListItem>

                        {links.map((link) => {
                            if (link) {
                                return (
                                    <ListItem key={link.title} onClick={link.onClick || this.onNavigate.bind(this, link.target)}>
                                        {link.icon && <i style={{marginRight: 10, fontSize: 20}} className={link.icon} />}
                                        <div>{link.title}</div>
                                    </ListItem>
                                )
                            }
                        })}
                    </div>
                }
            >

                <IconButton icon={icon} />
            </Popover>
        )
    }
}
